export const isEmptyObj = (obj: Object): boolean => {
  if (!obj) return true;
  return JSON.stringify(obj) === '{}';
};
